import { Siterecord } from 'app/models';
import { IntendedUsageType, TranslatableIntendedUsageType } from 'app/models/enums';

export class IntendedUsageUtil {
  public static parseIntendedUsageTypeAsString = (location?: Siterecord): string => {
    const usageType = IntendedUsageUtil.parseIntendedUsageType(location);
    return usageType ? usageType.valueOf() : null;
  }

  public static parseIntendedUsageType = (location?: Siterecord): TranslatableIntendedUsageType => {
    if (location && location.intendedUsageType) {
      return IntendedUsageUtil.convertIntendedUsageType(location.intendedUsageType, false);
    } else if (location && location.contract && location.contract.intendedUsageType) {
      return IntendedUsageUtil.convertIntendedUsageType(location.contract.intendedUsageType, true);
    }
  }

  public static convertIntendedUsageType = (
    intendedUsageType: IntendedUsageType,
    isContract: boolean
  ): TranslatableIntendedUsageType => {
    switch (intendedUsageType) {
      case IntendedUsageType.REALTIME:
        return isContract ? TranslatableIntendedUsageType.CONTRACT_REALTIME : TranslatableIntendedUsageType.REALTIME;
      case IntendedUsageType.ANALYTICS:
        return isContract ? TranslatableIntendedUsageType.CONTRACT_ANALYTICS : TranslatableIntendedUsageType.ANALYTICS;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/intended-usage.util.ts